import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/common.css'
import '@/assets/css/font.css'

Vue.config.productionTip = false

// ========== 全局：判断是否移动端 ==========
// Vue.prototype.isMobile = false
// // 判断移动端方法
// function checkMobile() {
//   const ua = navigator.userAgent.toLowerCase()
//   const mobileReg = /android|iphone|ipad|ipod|windows phone/i
//   Vue.prototype.isMobile = mobileReg.test(ua) || window.innerWidth < 800
// }

// // 页面加载执行一次
// checkMobile()

// // 窗口缩放/旋转时重新判断
// window.addEventListener('resize', checkMobile)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
